<template>
	<ActivityLayout class="goal-kr-owner-activity">
		<template #badge>
			<AssignmentChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				name: activity.name,
				changedBy: activity.changedBy,
				from: activity.from,
				to: activity.to
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import AssignmentChangeActivityBadge from "../Activity/AssignmentChangeActivityBadge.vue";

export default {
	name: "GoalKROwnerActivity",
	components: {
		ActivityLayout,
		AssignmentChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, name:String, from:String, to:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalKROwnerActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
